import React from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import api, { apiErr } from "@/lib/api";
import { toast } from "@/components/ui/sonner";
import { RefreshCw } from "lucide-react";

// Re-reads department + role of every employee from Team and pushes them to payroll runs, budget & annual report.
export const RefreshIdentityButton = ({ className = "" }) => {
  const qc = useQueryClient();
  const m = useMutation({
    mutationFn: async () => (await api.post("/payroll/refresh-identity")).data,
    onSuccess: (d) => { qc.invalidateQueries(); toast.success(`Ενημερώθηκαν τμήμα/ρόλος για ${d.refreshed} υπαλλήλους`); },
    onError: (e) => toast.error(apiErr(e)),
  });
  return (
    <button data-testid="refresh-identity-btn" onClick={() => m.mutate()} disabled={m.isPending} title="Ξαναδιαβάζει τμήμα & ρόλο από το Team"
      className={`inline-flex items-center gap-2 rounded-xl border border-[#E3DED4] bg-white px-3 py-2 text-sm font-semibold text-[#45423C] hover:border-[#45423C] disabled:opacity-50 ${className}`}>
      <RefreshCw className={`h-4 w-4 ${m.isPending ? "animate-spin" : ""}`} /> Ανανέωση ρόλων/τμημάτων
    </button>
  );
};
